import React, { createContext, useContext, useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

interface AuthContextType {
  login: () => void;
  logout: () => void;
  isAuthenticated: boolean;
  userName: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const userName = accounts.length > 0 ? accounts[0].name || null : null;

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        instance.setActiveAccount(response.account);
      }
    }).catch(err => {
      console.error("Redirect error:", err);
    });
  }, [instance]);

  //redirect to login if user is not authenticated
  useEffect(() => {
    if (!isAuthenticated && inProgress === "none") {
      instance.loginRedirect(loginRequest).catch(e => {
        console.error("Auto-login error");
      });
    }
  }, [isAuthenticated, inProgress, instance]);

  const login = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  const logout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, userName }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};